const state = {
    document_types: {
         
    }
}

export default state